// @flow

import * as React from 'react';

import { TripSocialActionBar } from '@ta/trips.social';

import TripSection, { type TripSectionProps } from '@ta/social.section-trip';
import SocialStatisticsBar from '@ta/social.statistics-bar';
import { getDisplayName } from '@ta/social.member';
import { InteractionLogger } from '@ta/tracking.interactions';
import { TitleBar } from '@ta/modal.headers';
import { localize } from '@ta/common.i18n';
import { Modal } from '@ta/overlays.modal';
import { CollaboratorPanel } from '@ta/trips.collaboration';
import * as Types from '@ta/trips.trip-types';

type Props = $Diff<
  TripSectionProps,
  {| socialStatisticsBar?: React.Node, socialActionBar?: React.Node |},
>;

type CollabModalProps = {|
  trip: Types.Trip,
  name: string,
|};

const CollaboratorModal = (props: CollabModalProps) => {
  const header = (
    <TitleBar iconName="users" displayType="LEFT_ALIGN_GRAY">
      <span>{localize('saves_Collaborators') /* Collaborators */}</span>
    </TitleBar>
  );

  return (
    <Modal name={props.name} header={header}>
      <CollaboratorPanel trip={props.trip} readOnly avatarNotLazy />
    </Modal>
  );
};

const TripSectionWrap = (props: Props) => {
  const { member, actor, trip, isEmbedded } = props;

  // Associate this component with a unique ID
  const { current: collabModalName } = React.useRef(
    `collabModal${trip.object.id}_${Math.random()}`,
  );

  if (!trip || !trip.object) {
    return null;
  }

  const socialStatisticsBar = isEmbedded ? null : (
    <SocialStatisticsBar
      stats={trip.object.socialStatistics || {}}
      socialRef={{
        type: 'Trip',
        id: `${trip.object.id}`,
      }}
      socialProofParams={{ displayName: getDisplayName(actor) }}
      deduplicate
    />
  );

  const socialActionBar = isEmbedded ? null : (
    <InteractionLogger>
      {logInteraction => (
        <TripSocialActionBar
          trip={trip}
          member={member}
          actor={actor}
          shareType="PUBLIC"
          justifyContent="SPACE_BETWEEN"
          onSaveAllClick={e => {
            logInteraction(e, 'trip_save');
          }}
        />
      )}
    </InteractionLogger>
  );

  const collabModal = <CollaboratorModal trip={trip.object} name={collabModalName} />;

  return (
    <TripSection
      {...props}
      socialStatisticsBar={socialStatisticsBar}
      socialActionBar={socialActionBar}
      collaborationModal={collabModal}
      collaborationModalName={collabModalName}
    />
  );
};

export default TripSectionWrap;
